import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CompanyEmissionsWasteDto, UpsertEmissionsWasteRequest } from '../../models/api/companyEmissionsWasteDto';
import { YearlyResource } from '../../models/api/yearlyResource';
import { DefaultCurrencyContext } from '../../models/api/defaultCurrencyContext';

@Injectable({
  providedIn: 'root'
})
export class CompanyEmissionsWasteService {
  private apiUrl = `${environment.apiUrl}/companies`;

  constructor(private http: HttpClient) {}

  get(companyId: string, year?: number): Observable<YearlyResource<CompanyEmissionsWasteDto, DefaultCurrencyContext>> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.get<YearlyResource<CompanyEmissionsWasteDto, DefaultCurrencyContext>>(
      `${this.apiUrl}/${companyId}/emissions-and-waste`,
      { params }
    );
  }

  upsert(companyId: string, request: UpsertEmissionsWasteRequest): Observable<CompanyEmissionsWasteDto> {
    return this.http.put<CompanyEmissionsWasteDto>(`${this.apiUrl}/${companyId}/emissions-and-waste`, request);
  }

  delete(companyId: string, year?: number): Observable<void> {
    let params = new HttpParams();
    if (year !== undefined) {
      params = params.set('year', year.toString());
    }
    return this.http.delete<void>(`${this.apiUrl}/${companyId}/emissions-and-waste`, { params });
  }
}
